/* Progressive enhancement: Shopify continues to own navigation, forms and cart. */
(() => {
  const desktop = window.matchMedia('(min-width: 768px)');
  function prepareFooter(root = document) {
    root.querySelectorAll('.atelier-footer__group').forEach((group) => {
      if (group.dataset.atelierReady) return;
      group.dataset.atelierReady = 'true';
      const summary = group.querySelector('summary');
      const sync = () => {
        group.open = desktop.matches;
        summary.tabIndex = desktop.matches ? -1 : 0;
      };
      summary.addEventListener('click', (event) => {
        if (desktop.matches) event.preventDefault();
      });
      desktop.addEventListener('change', sync);
      sync();
    });
  }
  function prepareSizeDialogs() {
    document.querySelectorAll('#sjsRingGuideModal, #SjsRingSizeModal').forEach((modal) => {
      if (modal.dataset.atelierFocus) return;
      modal.dataset.atelierFocus = 'true';
      let wasOpen = false;
      let previousFocus;
      const isOpen = () => !modal.hidden && modal.getAttribute('aria-hidden') !== 'true' && getComputedStyle(modal).display !== 'none';
      const controls = () => [...modal.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select,textarea,iframe,[tabindex="0"]')].filter((element) => element.getClientRects().length);
      new MutationObserver(() => {
        const open = isOpen();
        if (open && !wasOpen) {
          previousFocus = document.activeElement;
          const close = modal.querySelector('.sjs-modal-close-btn, .sjs-size-modal__close');
          if (close) close.focus();
        } else if (!open && wasOpen && previousFocus?.isConnected) {
          previousFocus.focus();
        }
        wasOpen = open;
      }).observe(modal, { attributes: true, attributeFilter: ['hidden', 'aria-hidden', 'style'] });
      modal.addEventListener('keydown', (event) => {
        if (!isOpen()) return;
        if (event.key === 'Escape' && modal.id === 'sjsRingGuideModal') {
          event.preventDefault();
          modal.querySelector('.sjs-modal-close-btn')?.click();
        }
        if (event.key !== 'Tab') return;
        const items = controls();
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      });
    });
  }
  const prepare = () => { prepareFooter(); prepareSizeDialogs(); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepare);
  } else {
    prepare();
  }
  document.addEventListener('shopify:section:load', prepare);
})();

// Price shortcuts use the native Shopify facet component, including section updates.
document.addEventListener('click', (event) => {
  const apply = event.target.closest('.sjs-price-apply');
  if (apply) {
    apply.closest('price-facet-component').updatePriceFilterAndResults();
    return;
  }
  const preset = event.target.closest('.sjs-price-pill');
  if (!preset) return;
  const facet = preset.closest('price-facet-component');
  const min = facet?.querySelector('[ref="minInput"]');
  const max = facet?.querySelector('[ref="maxInput"]');
  if (!min || !max) return;
  min.value = preset.dataset.min || '';
  max.value = preset.dataset.max || '';
  facet.updatePriceFilterAndResults();
});
